import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import { BlockType, ComponentSettings, DatasetFieldValueType, NewBlockContextType } from '@report-content';
import { AssocArray, YNValues } from 'tools/types';

export class BlockFactoryExternalVisualization extends AbstractBlockFactory<ComponentSettingsExternalVisualization> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsExternalVisualization> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'external_visualization',
                settings: {
                    uid: uid,
                    title: '',
                    height: 600,
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    is_collapsed_ind: 'N',
                    include_in_email: 'Y',
                    include_in_email_attachment: 'Y',
                    internal_name: 'external_visualization',
                    groupFilter: { operator: 'AND', rules: [] },
                    dataQueries: {
                        table: {
                            resultFields: ['*'],
                            resultFieldAggregations: {},
                            limit: 1,
                        },
                    },
                    filters: [],
                    filtersOnDataset: [],
                    // groupFilter: any,
                    // internal_name: 'external_visualization',
                    // is_preview_ind: YNValues,
                    link_to_dataset: 'N',
                    report_ext_vis_applicable_scope: 'row',
                    // report_ext_vis_display: string,
                    report_ext_vis_element_id: 0,
                    // report_ext_vis_iframe_height: number,
                    // report_ext_vis_iframe_height_defined: boolean,
                    report_ext_vis_images_in_email: 10,
                    report_max_viz_number_to_display: 5,
                    // report_multiple_units_label: string,
                    // report_no_units_label: 'No rows',
                    report_refer_from_email_to: 'ext_vis',
                    // report_single_unit_label: 'row',

                    show_title: 'Y',
                    isOnCreation: true,
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ExternalVisualizationInitialDataResponse {
    displayOpenLink: YNValues;
    dataResults: { table: [AssocArray<string>] };
    visualizations: [
        {
            filters?: string;
            hash?: string;
            prompts?: Array<any>;
            url: string;
            url_external?: string;
        },
    ];
}

export interface ComponentSettingsExternalVisualizationMapColumnFilter {
    // aggregate_function: '';
    // aggregation: false;
    // all_values: 'All';
    // column_instance: 'current';
    column_name: string;
    // column_sequence: 0;
    // compute_result_total_ind: 'N';
    dataset_column_id: number;
    dataset_filter_column_id: number;
    dataset_filter_id: number;
    dataset_id: number;
    display_mask_id?: string;
    display_name_label: string;
    external_filter_id: number;
    // field: 'calendar_date';
    // id: 'calendar_date';
    // instance: 'current';
    // is_derived_ind: 'N';
    // is_result_ind: 'Y';
    // key: 'calendar_date-current';
    // label: 'calendar_date';
    // label_new: 'calendar_date';
    name: string;
    // ref_column_name: string;
    reference_name: string;
    // reference_name_escaped: 'calendar_date';
    // sub_total_placement: 'top';
    // use_formatted_value_ind: 'N';
    value_type: DatasetFieldValueType;
}

export interface ComponentSettingsExternalVisualizationDataQueries {
    table?: {
        resultFields: Array<string>;
        resultFieldAggregations: any;
        limit: number;
    };
    filters?: {
        resultFields: Array<string>;
        displayMasks: AssocArray<string>;
        distinct: boolean;
    };
}

export interface ComponentSettingsExternalVisualization extends ComponentSettings {
    uid: string;
    dataQueries: ComponentSettingsExternalVisualizationDataQueries;
    filters: Array<ComponentSettingsExternalVisualizationMapColumnFilter>;
    filtersOnDataset: Array<ComponentSettingsExternalVisualizationMapColumnFilter>;
    // filtersOnDataset: [],
    // groupFilter: any,
    // internal_name: 'external_visualization',
    // is_preview_ind: YNValues,
    link_to_dataset: YNValues | 'D';
    report_ext_vis_applicable_scope: 'row' | 'once';
    // report_ext_vis_display: string,
    report_ext_vis_element_id: number;
    // report_ext_vis_iframe_height: number,
    // report_ext_vis_iframe_height_defined: boolean,
    report_ext_vis_images_in_email: number;
    report_max_viz_number_to_display: number;
    // report_multiple_units_label: string,
    // report_no_units_label: 'No rows',
    report_refer_from_email_to: 'ext_vis' | 'self';
    // report_single_unit_label: 'row',
    dataset_block_uid?: string;
    show_title: YNValues;
    userSelectedViz?: string;
}
